module.exports = __webpack_public_path__ + "img/alt.301f819d.svg";